import Modal from 'react-bootstrap/Modal';
import { Field, Form, Formik } from "formik";
import { TextField } from "../../components/common/TextField/TextField";
import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { filesTo, fileUrl } from "../../api/api";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const productTypesData = [
    { id: 1, name: "Nevrologiya" },
    { id: 2, name: "Kardiologiya" },
    { id: 3, name: "Travmatologiya" },
    { id: 4, name: "Daxili xəstəliklər" },
    { id: 5, name: "Revmatologiya" },
    { id: 6, name: "Endokrinologiya" },
    { id: 7, name: "Ortopediya" },
    { id: 8, name: "Radiologiya" },
    { id: 9, name: "İmmunologiya" },
    { id: 10, name: "Digər" }
];

const AddDataModal = ({ show, addBlogTh, setIsCreateBlog, ...props }) => {
    let [content, setContent] = useState("");
    let [imageUrl, setImageUrl] = useState("");
    let [isUploading, setIsUploading] = useState(false); // Yüklənmə indikatoru üçün
    let [showModal, setShowModal] = useState(show);

    const handleClose = () => {
        setShowModal(false);
        setIsCreateBlog(false);
    };

    const saveCkEditorHTML = (e, editor) => {
        setContent(editor.getData());
    };

    // Preview URL-i təhlükəsiz qururuq: backend "abc.jpg" və ya "files/abc.jpg" qaytara bilər
    const buildPreviewUrl = (path) => {
        if (!path) return "";
        if (path.startsWith("http")) return path;
        const base = fileUrl.replace(/\/+$/, "");
        const normalized = path.replace(/^\/+/, "").startsWith("files/")
            ? path.replace(/^\/+/, "")
            : `files/${path.replace(/^\/+/, "")}`;
        return `${base}/${normalized}`;
    };

    // Şəkil seçildikdə avtomatik işə düşən funksiya
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        const folderType = "blog";

        try {
            const responseFileLoad = await filesTo.add(file, folderType);

            if (responseFileLoad && responseFileLoad.status === 200) {
                ShowNotification("Uğurlu", "Şəkil yükləndi", "success");
                // Backend "files/abc.jpg" qaytarır — təkrar "files/" əlavə etmirik
                const filePath = responseFileLoad.data.url; // Backend-dən gələn şəkil yolu
                setImageUrl(filePath);
            } else {
                ShowNotification("Xəta", responseFileLoad?.data?.message || "Şəkil yüklənmədi", "danger");
            }
        } catch (error) {
            ShowNotification("Xəta", "Şəkil yüklənərkən xəta baş verdi", "danger");
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        setShowModal(show);
    }, [show]);

    return (
        <Formik
            initialValues={{
                title: "",
                product_type_id: "",
                youtubeLink: "",
                status: 1,
            }}
            onSubmit={(formValues) => {
                if (isUploading) {
                    ShowNotification("Xəbərdarlıq", "Zəhmət olmasa şəklin yüklənməsini gözləyin", "warning");
                    return;
                }

                const blogInstance = {
                    title: formValues.title,
                    content: content,
                    imgUrl: imageUrl,
                    product_type_id: formValues.product_type_id || null, // Yeni kateqoriya id-si
                    youtubeLink: formValues.youtubeLink ? formValues.youtubeLink.replace("watch?v=", "embed/") : "",
                    status: 1,
                };

                addBlogTh(blogInstance);
                setIsCreateBlog(false);
            }}
        >
            {() => (
                <Modal show={showModal} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Məhsul / Blog Əlavə Et</Modal.Title>
                    </Modal.Header>
                    <Form>
                        <Modal.Body>
                            <TextField
                                label="Blog Adı"
                                name="title"
                                type="text"
                                enableLabel="true"
                            />

                            {/* Kateqoriya Seçimi (Product Type) */}
                            <div className="form-group mb-3">
                                <label className="form-label font-weight-bold">Kateqoriya (Product Type)</label>
                                <Field as="select" name="product_type_id" className="form-control shadow-none">
                                    <option value="">-- Kateqoriya Seçin --</option>
                                    {productTypesData.map((type) => (
                                        <option key={type.id} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </Field>
                            </div>

                            <div className="form-group mb-3">
                                <label className="form-label font-weight-bold">Kontent</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={content || ""}
                                    name="content"
                                    onChange={saveCkEditorHTML}
                                />
                            </div>

                            {/* Avtomatik Şəkil Yükləmə Bölməsi */}
                            <div className="form-group mb-3">
                                <label className="form-label font-weight-bold">Şəkil Əlavə Et</label>
                                <Row className="align-items-center">
                                    <Col md={imageUrl ? 8 : 12}>
                                        <input
                                            name="imgUrl"
                                            id="upload"
                                            type="file"
                                            accept="image/*"
                                            className="form-control shadow-none"
                                            onChange={handleFileChange}
                                        />
                                    </Col>
                                    {isUploading && (
                                        <Col md={12} className="mt-2 text-info">
                                            <Spinner animation="border" size="sm" me={2} /> Şəkil yüklənir, gözləyin...
                                        </Col>
                                    )}
                                </Row>

                                {/* Yüklənən şəklin önbaxışı (Preview) */}
                                {imageUrl && !isUploading && (
                                    <div className="mt-2">
                                        <small className="text-success d-block mb-1">✔ Şəkil hazırda yükləndi:</small>
                                        <img
                                            src={buildPreviewUrl(imageUrl)}
                                            alt="Uploaded Preview"
                                            style={{ maxHeight: "100px", borderRadius: "5px", objectFit: "cover" }}
                                        />
                                    </div>
                                )}
                            </div>

                            <TextField
                                label="Youtube Link"
                                name="youtubeLink"
                                type="text"
                                enableLabel="true"
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                Bağla
                            </button>
                            <button
                                type="submit"
                                disabled={isUploading}
                                className="btn btn-primary"
                            >
                                Yadda Saxla
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </Formik>
    );
};

export default AddDataModal;
